export default __webpack_public_path__ + "static/media/arr.1d7ce410.svg";